export const documentStatusOptions = ['Pending', 'Accepted', 'Signed'] as const;
export type DocumentStatus = (typeof documentStatusOptions)[number];

export type DocumentsToolboxForm = {
  status?: DocumentStatus;
  documentType?: string;
  name?: string;
};

export type DocumentsParams = {
  documentId?: string;
  status?: DocumentStatus;
  documentType?: string;
  name?: string;
};

export type SetDocumentParams = (params: Partial<DocumentsParams>) => void;

export const DOCUMENTS_INITIAL_VALUES = {
  documentId: {
    initialValue: undefined,
    type: 'string',
  },
  status: {
    initialValue: undefined,
    type: 'string',
  },
  documentType: {
    initialValue: undefined,
    type: 'string',
  },
  name: {
    initialValue: undefined,
    type: 'string',
  },
} as const;

export const mapToDocumentStatus = (value: string | undefined): DocumentStatus | undefined => {
  if (value === 'Pending' || value === 'Accepted' || value === 'Signed') {
    return value;
  }
  return undefined;
};
